import { API_TYPE } from '@umu/umu-fetch';
const BASE_API = '/uapi/v1';
const CoursePath = '/uapi/v1/course';
const ElementPath = '/uapi/v1/element';

export const CourseAPI = {
    GAMIFICATION_INFO: {
        url: `${ElementPath}/gamification-info`,
        type: API_TYPE.GET,
    },
    AROUND_RANK: {
        url: `/api/points/getaroundpointsrank`,
        type: API_TYPE.GET,
    },
    LAST_LEARNING_ELEMENT: {
        url: `${CoursePath}/next-learning-element`,
        type: API_TYPE.GET,
    },
    COURSE_LEGRESS: {
        url: `${CoursePath}/get-learning-progress`,
        type: API_TYPE.GET,
    },

    GET_COURSE_PK_INFO: {
        url: `${CoursePath}/activity-get`,
        type: API_TYPE.GET,
    },
    GET_COURSE_PK_LIST: {
        url: `${CoursePath}/activity-list`,
        type: API_TYPE.GET,
    },
    UPDATE_ACCESS_USER: {
        url: '/api/manage/updateaccessuser',
        type: API_TYPE.GET,
    },
    GET_COURSE_TYPE_SESSIONS: {
        url: `${BASE_API}/element/list-by-type`,
        type: API_TYPE.GET,
    },
    SAVE_COURSE_PK_INFO: {
        url: `${CoursePath}/activity-save`,
        type: API_TYPE.POSTFORMDATA,
    },
    SAVE_COURSE_PK_TEAMS: {
        url: `${CoursePath}/activity-team-save`,
        type: API_TYPE.POSTFORMDATA,
    },
    COURSE_PK_FINISH: {
        url: `${CoursePath}/activity-finish`,
        type: API_TYPE.POSTFORMDATA,
    },
    COURSE_PK_DELETE: {
        url: `${CoursePath}/activity-delete`,
        type: API_TYPE.POSTFORMDATA,
    },
    GET_COURSE_PK_LEADERBOARD: {
        url: `${CoursePath}/activity-metrics-list`,
        type: API_TYPE.POSTFORMDATA,
    },
    CHANGE_COURSEPK_TEAM_SCORE: {
        url: `${CoursePath}/activity-metrics-change`,
        type: API_TYPE.POSTFORMDATA,
    },
    GET_COURSE_PK_TEAMS: {
        url: `${CoursePath}/activity-team-list`, // 课程PK团队列表
        type: API_TYPE.GET,
    },
    GET_COURSE_PK_TEAM_USERS: {
        url: `${CoursePath}/activity-team-user`, // 课程PK团队打平的成员列表
        type: API_TYPE.POSTFORMDATA,
    },
    GET_COURSE_PK_TEAM_STRUCTURE_USERS: {
        url: `${CoursePath}/activity-team-member-detail`, // 课程PK团队有结构的成员列表
        type: API_TYPE.POSTFORMDATA,
    },
    GET_GROUP_MEMBERS: {
        url: `/ajax/enterprise/getUserList`, // 获取分组成员
        type: API_TYPE.GET,
    },
    GET_CLASS_MEMBERS: {
        url: `${BASE_API}/class/member-list`, // 获取班级成员
        type: API_TYPE.GET,
    },
    GET_COURSE_COOPERATION_ROLE: {
        url: `${BASE_API}/cooperation/is-manager`,
        type: API_TYPE.GET,
    },
};
